import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
import {TmwTranslateDirective} from '@shared/directives/translate.directive';

@Component({
  selector: 'tmw-search-errorMessage',
  standalone: true,
  templateUrl: './search-errorMessage.component.html',
  imports: [CommonModule, TmwTranslateDirective],
  styleUrl: './search-errorMessage.component.scss',
})
export class SearchErrorMessageComponent {}
